import type { SatisfactionAnswers, SatisfactionQuestion } from './types';

export const RATING_LABELS = [
  'Très insatisfait',
  'Insatisfait',
  'Neutre',
  'Satisfait',
  'Très satisfait',
];
export const answered = (answer: number | string | undefined) =>
  typeof answer === 'number' ? answer >= 1 && answer <= 5 : Boolean(answer?.trim());

/** Aperçu uniquement : le serveur recalcule le taux enregistré. */
export const previewSatisfaction = (
  questions: SatisfactionQuestion[],
  answers: SatisfactionAnswers,
) => {
  let points = 0;
  let weights = 0;
  for (const question of questions) {
    const answer = answers[question.id];
    if (question.type !== 'rating' || typeof answer !== 'number' || !answered(answer)) continue;
    points += (answer - 1) * question.weight;
    weights += question.weight;
  }
  return weights ? Math.round((points / (weights * 4)) * 10_000) / 100 : null;
};

export const formatSatisfaction = (score: number) =>
  `${score.toLocaleString('fr-FR', { maximumFractionDigits: 1 })} %`;
